import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * スクロールアニメーション - scroll-in クラスを追加
 * @param {string} eventClass - アニメーション対象のクラス名
 */
export function animation(eventClass) {
  const eventElms = document.getElementsByClassName(eventClass);
  if (!eventElms.length) return;

  for (let i = 0; i < eventElms.length; i++) {
    const elm = eventElms[i];

    // scroll-in クラスを追加してCSSアニメーションをトリガー
    ScrollTrigger.create({
      trigger: elm,
      start: 'top 80%',
      onEnter: () => {
        elm.classList.add('scroll-in');
      },
    });
  }
}

/**
 * 即時アニメーション - scroll-in クラスを即座に追加
 * @param {string} eventClass - アニメーション対象のクラス名
 */
export function animationImmediate(eventClass) {
  const eventElms = document.getElementsByClassName(eventClass);
  if (!eventElms.length) return;

  for (let i = 0; i < eventElms.length; i++) {
    eventElms[i].classList.add('scroll-in');
  }
}

/**
 * タイプライターアニメーション
 * @param {string} eventClass - アニメーション対象のクラス名
 */
export function typewriter(eventClass) {
  const eventElm = document.getElementsByClassName(eventClass);
  if (!eventElm.length) return;

  for (let i = 0; i < eventElm.length; i++) {
    const text = eventElm[i].textContent;
    eventElm[i].textContent = '';
    eventElm[i].style.visibility = 'visible';
    eventElm[i].classList.add('scroll-in');

    const chars = text.split('');
    chars.forEach((char, index) => {
      setTimeout(() => {
        eventElm[i].textContent += char;
      }, index * 50);
    });
  }
}
